import Component from '@glimmer/component';
import * as LottiePlayer from '@lottiefiles/lottie-player';

export default class MwLottiePlayer extends Component {

}
